<template>
  <div class="row">
    <div class="col-12 col-md-6 col-xl-4 mx-auto mt-5 text-center">
      <div class="card bg-light mt-5">
        <div class="card-body">
          <img :src="require('../assets/logo.png')" alt="logo" class="card-title mb-4 mt-4">
          <div class="input-group mb-4 col-8 mx-auto">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fas fa-user"></i>
              </span>
            </div>
            <input
              v-model="username"
              type="text"
              class="form-control"
              placeholder="Nom d'utilisateur"
            >
          </div>
          <div class="input-group mb-4 col-8 mx-auto">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fas fa-key"></i>
              </span>
            </div>
            <input
              v-model="password"
              type="password"
              class="form-control"
              placeholder="Mot de passe"
            >
          </div>
          <button v-on:click="auth()" type="button" class="btn btn-primary btn-lg mt-4">Connexion</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

import endpoints from "../endpoints";

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    auth: function() {
      axios
        .post(endpoints.login, {
          username: this.username,
          password: this.password
        })
        .then(response => {
          localStorage.token = response.data.token;
          this.$parent.refresh();
        })
        .catch(() => {
          this.$parent.addErrorMessage(
            "Le nom d'utilisateur ou le mot de passe incorrect."
          );
        });
    }
  }
};
</script>
<style scoped>
</style>
